<template>
  <section id="what">
    <div class="container">
      <v-spacer size="100px"></v-spacer>
      <h2>I build creative websites from top to bottom.</h2>
      <v-spacer size="100px"></v-spacer>
      <div class="bs_row">
        <div class="bs_one">
          <card
            image="/images/what_design.jpg"
            title="design"
            description="Early in my life, I wanted to be a cartoonist and a writer! Nowadays I expend that creative energy on designing websites and associated branding for my lovely clients."
          />
          <v-spacer size="1rem"></v-spacer>
        </div>
        <div class="bs_one">
          <card
            image="/images/what_develop.jpg"
            title="develop"
            description="Just think of me as an artsy full stack developer who likes to create beautiful responsive websites and is comfortable working on both the frontend and the backend."
          />
          <v-spacer size="1rem"></v-spacer>
        </div>
      </div>
      <div class="bs_row">
        <div class="bs_one">
          <card
            image="/images/what_test.jpg"
            title="test"
            description="Between Test Driven Development, unit testing, automation, and good old-fashioned eyeballs on real devices, my websites are about as close to pixel perfect as you can get."
          />
          <v-spacer size="1rem"></v-spacer>
        </div>
        <div class="bs_one">
          <card
            image="/images/what_deploy.jpg"
            title="deploy"
            description="Need dev ops? Whether it's building servers or setting up continuous integration, I'll create and maintain your application environments wherever they may be. Have you heard of the cloud? I know about clouds."
          />
          <v-spacer size="1rem"></v-spacer>
        </div>
      </div>
      <v-spacer size="100px"></v-spacer>
    </div>
  </section>
</template>

<script>
  import Card from './Card'
  import VSpacer from './VSpacer'

  export default {
    name: 'What',
    components: {
      Card,
      VSpacer
    }
  }
</script>
